import React, { useEffect, useRef, useState } from "react";
import BlockUi from "react-block-ui"; 
import { withNamespaces } from "react-i18next";
import { withHeaderTitle } from "../../../components/Header/HeaderTitle";
// componentes
import ChartCustom from "../../GoogleChart/ChartCustom";
import ChartCustomNegative from "../../GoogleChart/ChartCustomNegative";
import ChartArea from "../../GoogleChart/ChartArea";
import VerticalChart from "../../GoogleChart/VerticalChart";
// funciones
import { getChart } from "../../../services/dashboardServices/serviceProblemGraphics";
// estilos.
import "react-block-ui/style.css";
import "../Dashboard.scss";

const CalidadVidaScreen = (props) => {
  props.setHeaderTitle("Calidad de vida y Covid");
  const isMounted = useRef(false);
  const [blocking, setBlocking] = useState(false);
  const filters = props.filters;
  const onSearch = props.onSearch;
  const setOnSearch = props.setOnSearch;
  // graficos.
  const [columChartLife, setColumChartLife] = useState({ data: [], titles: [] });
  const [columChartLifev2, setColumChartLifev2] = useState({ data: [], titles: [] });
  const [columChartLife18, setColumChartLife18] = useState({ data: [], titles: [], referencias: {} });
  const [columCharBeforeYear, setColumCharBeforeYear] = useState({ data: [], titles: [], referencias: {}, order: [] });
  const [columCharAfterYear, setColumCharAfterYear] = useState({ data: [], titles: [], referencias: {}, order: [] });
  const [columChar25Mejorado, setColumChar25Mejorado] = useState({ data: [], titles: [], referencias: {}  });
  const [columCharEmpeorado, setColumCharEmpeorado] = useState({ data: [], titles: [], referencias: {}  });
  // prueba lista años.
  // const [medicionesYear, setMedicionesYear] = useState(['2020']); 

  const loadCharLife = async () => {
    setBlocking(true);
    const config = { params: filters, method: "GET", urlApi: "chart16-satisfaccion" };
    const data = await getChart(config);
    const titles = ["Opciones", "GSE"];

    if (isMounted.current) {
      setColumChartLife({ 
        data: data.rows, 
        titles: titles 
      });
    }
    
    setBlocking(false);
  };

  const loadCharLife16v2 = async () => {
    setBlocking(true);
    const config = { params: filters, method: "GET", urlApi: "chart16v2-satisfaccion" };
    const data = await getChart(config);
    const titles = ["Opciones", "GSE"];
    if (isMounted.current) {
      setColumChartLifev2({ 
        data: data.rows, 
        titles: titles 
      });
    }
    setBlocking(false);
  };

  const loadCharLife18 = async () => {
    setBlocking(true);
    const data = await getChart({params: filters,method: 'GET',urlApi: 'chart18-satisfaccion' });
    
    const iterableTitles = data.newMedicionList.reduce((acc, current) => {
      return acc = [ ...acc, `${current} % Neto`, {role:'annotation'} ]
    }, ['Valores']);
    
    console.log(data.rows);
    if(isMounted.current) {
      setColumChartLife18({ 
        data: data.rows, 
        titles: iterableTitles
      })
    }; 
    
    setBlocking(false);
    // setBlocking(true);
    // const config = { params: filters, method: "GET", urlApi: "chart18-satisfaccion" };
    // const data = await getChart(config);
    

    // if (isMounted.current) {
    //   setColumChartLife18({ 
    //     data: data.rows, 
    //     titles: iterableTitles,
    //     referencias: data.referencias
    //   });
    // }
    
    // setBlocking(false);
  };

  const loadCharBeforeYear = async () => {
    setBlocking(true);
    const config = { params: filters, method: "GET", urlApi: "chart23v1-satisfaccion" };
    const data = await getChart(config);
    const iterableTitles = data.medicionList.reduce((acc, current) => {
      return acc = [ ...acc, `% ${current}`, {role:'annotation'} ]
    }, ['Valores']);



    if (isMounted.current) {
      setColumCharBeforeYear({ 
        data: data.rows, 
        order: data.order,
        referencias: data.referencias || null,
        titles: iterableTitles 
      });
    }
    
    setBlocking(false);
  };

  const loadCharAfterYear = async () => {
    setBlocking(true);
    const config = { params: filters, method: "GET", urlApi: "chart23v2-satisfaccion" };
    const data = await getChart(config);
    const iterableTitles = data.medicionList.reduce((acc, current) => {
      return acc = [ ...acc, `% ${current}`, {role:'annotation'} ]
    }, ['Valores']);

    if (isMounted.current) {
      setColumCharAfterYear({ 
        data: data.rows,
        order: data.order,
        referencias: data.referencias || null,
        titles: iterableTitles 
      });
    }
    
    setBlocking(false);
  };

  const loadChar25Mejorado = async () => {
    setBlocking(true);
    // console.log(`CONSOLE`);
    // console.log(filters);
    const filterAux = {
      medicion: [
        "2020",
        "2021"
      ],
    }
    const config = { params: filterAux, method: "GET", urlApi: "chart25v1-mejorado" };
    const data = await getChart(config);
    const iterableTitles = data.medicionList.reduce((acc, current) => {
      return acc = [ ...acc, `% ${current}`, {role:'annotation'} ]
    }, ['Valores']);
    
    if (isMounted.current) {
      setColumChar25Mejorado({ 
        data: data.rows, 
        titles: iterableTitles,
        referencias: data.referencias,
      });
    }
    
    setBlocking(false);
  };

  const loadCharEmpeorado = async () => {
    setBlocking(true);
    const filterAux = {
      medicion: [
        "2020",
        "2021"
      ],
    }
    const config = { params: filterAux, method: "GET", urlApi: "chart25v1-empeorado" };
    const data = await getChart(config);
    const iterableTitles = data.medicionList.reduce((acc, current) => {
      return acc = [ ...acc, `% ${current}`, {role:'annotation'} ]
    }, ['Valores']);
    
    if (isMounted.current) {
      setColumCharEmpeorado({ 
        data: data.rows, 
        titles: iterableTitles,
        referencias: data.referencias,
      });
    }
    
    setBlocking(false);
  };

  const loadCharts = () => {
    loadCharLife();
    loadCharLife16v2();
    loadCharLife18();
    loadCharBeforeYear();
    loadCharAfterYear();
    loadChar25Mejorado();
    loadCharEmpeorado();
    setOnSearch(false);
  }

  useEffect(() => {
    isMounted.current = true;
    loadCharts();
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if(onSearch){
      loadCharts();
    }
  }, [ onSearch ])

  // efecto que el submit o reset del formulario.
  // useEffect(() => {
  //   filters.medicion ? setMedicionesYear(filters.medicion) : setMedicionesYear(['2020'])
  // }, [onSearch]);

  return (
    <BlockUi tag="div" blocking={blocking}>
      {/* Lamina 16: Satisfacción con la vida */}
      <div className={`row mb-2`}>
        {columChartLife.data.length > 0 && (
          <VerticalChart
            subTitle="Usando una escala de 1 a 7, donde 1 es  “Nada satisfecho” y 7 es “Muy satisfecho”, ¿Qué tan satisfecho estás con tu vida en general?"
            chartComment={"% Neto: % 6 a 7 - % 1 a 4"}
            dataChart={columChartLife.data}
            titles={columChartLife.titles}
            mediaQueries={{
              lx: "6",
              md: "6",
              xs: "12",
            }}
          />
        )}

        {columChartLifev2.data.length > 0 && (
          <VerticalChart
            subTitle="Usando una escala de 1 a 7, donde 1 es “Nada satisfecho” y 7 es “Muy satisfecho”, ¿Qué tan satisfecho crees que está el resto de los chilenos con su vida en general?"
            chartComment={"% Neto: % 6 a 7 - % 1 a 4"}
            dataChart={columChartLifev2.data}
            titles={columChartLifev2.titles}
            mediaQueries={{
              lx: "6",
              md: "6",
              xs: "12",
            }}
          />
        )}
      </div>

      {/* prueba 18. */}
      <div className="row">
        {columChartLife18.data.length > 0 && (
          <ChartCustomNegative  
            subTitle="¿Con qué nota evaluarías tu nivel de satisfacción con…?"
            chartCommentJsx={
              <div>
                {/* <p className="mb-0 text-muted">
                En 2022 no fueron medidos “Modelo económico”, “Sistema judicial”, “El sistema político chileno” ni “El trabajo que realiza en Gobierno”.
                </p>
                <p className="mb-0 text-muted">
                Se incluyó “Relación con tu pareja”.
                </p> */}
              </div>
            }
            dataChart={columChartLife18.data}
            titles={columChartLife18.titles}
            chartConfig={{
              height: '70vh',
              chartArea: { width: "80%", height: '60%' }
            }}
          />
        )}
        {/* {columChartLife18.data.length > 0 && (
          <ChartArea
            sort={true}
            subTitle="¿Con qué nota evaluarías tu nivel de satisfacción con…? 1"
            data={columChartLife18.data}
            referencias={columChartLife18.referencias}
            titles={columChartLife18.titles}
            chartConfig={{
              chartArea: { width: "90%", height: '60%' }
            }}
            chartCommentJsx={
              <div>
                <p className="mb-0 text-muted">
                En 2022 no fueron medidos “Modelo económico”, “Sistema judicial”, “El sistema político chileno” ni “El trabajo que realiza en Gobierno”.
                </p>
                <p className="mb-0 text-muted">
                Se incluyó “Relación con tu pareja”.
                </p>
              </div>
            }
          />
        )} */}
      </div>

      {/* gráfico: Lamina 23: 1° */}
      <div className="row mb-2">
        {columCharBeforeYear.data.length > 0 && (
          <ChartCustom
            replace
            order={columCharBeforeYear.order}
            dataChart={columCharBeforeYear.data}
            subTitle="En comparación a 1 año atrás, ¿Crees que actualmente tu calidad de vida ha..?"
            referencias={columCharBeforeYear.referencias}
            titles={columCharBeforeYear.titles} 
          />
        )}
      </div>

      {/* gráfico: Lamina 23: 2° */}
      <div className="row mb-2">
        {columCharAfterYear.data.length > 0 && (
          <ChartCustom
            replace
            dataChart={columCharAfterYear.data}
            order={columCharAfterYear.order}
            subTitle="En 1 año más, ¿esperas que tu calidad de vida ...?"
            referencias={columCharAfterYear.referencias}
            titles={columCharAfterYear.titles}
          />
        )}
      </div>

      {/* gráfico lamina 25 */}
      {/* <div className="row mb-2">
        {columChar25Mejorado.data.length > 0 && (
          <ChartCustom 
            applyFormat="TWO"
            sort={true}
            referencias={columChar25Mejorado.referencias}
            dataChart={columChar25Mejorado.data}
            subTitle="En comparación a 1 año atrás, ¿Cuáles de los siguientes aspectos de tu vida han mejorado?"
            chartComment='* comenzaron su medición el 2021.'
            chartCommentJsx={
              <div>
                <p className="mb-0 text-muted">
                Pregunta no realizada en 2022.
                </p>
              </div>
            }
            titles={columChar25Mejorado.titles} 
            chartConfig={{
              height: '70vh',
              chartArea: { width: "80%", height: '60%' }
            }}
          />
        )}
      </div> */}

      {/* <div className="row mb-2">
        {columCharEmpeorado.data.length > 0 && (
          <ChartCustom 
            applyFormat="TWO"
            sort={true}
            referencias={columCharEmpeorado.referencias}
            dataChart={columCharEmpeorado.data}
            subTitle="En comparación a 1 año atrás, ¿Cuáles de los siguientes aspectos de tu vida han empeorado?"
            chartComment='* comenzaron su medición el 2021.'
            chartCommentJsx={
              <div>
                <p className="mb-0 text-muted">
                Pregunta no realizada en 2022.
                </p>
              </div>
            }
            titles={columCharEmpeorado.titles} 
            chartConfig={{
              height: '80vh',
              chartArea: { width: "70%", height: '60%' }
            }}
          />
        )}
      </div> */}
    </BlockUi>
  );
};

export default withNamespaces("translations")(withHeaderTitle(CalidadVidaScreen));
